module.exports = __webpack_public_path__ + "img/R4DM25_Annual_Patch_2025_ol.b9fe90a8.png";